<script setup>
import { computed } from 'vue'
import QualificationBanner from '@components/player/QualificationBanner.vue'

const props = defineProps({
	player: {
		type: Object,
		required: true,
	},
	qualifications: {
		type: Array,
		default: () => [],
	},
})

const decorations = {
	star: 'https://cdn.snkesports.com/events/images/elements/player/star-outer.svg',
	avatarBackdrop: 'https://cdn.snkesports.com/events/images/elements/player/player-photo-bg.svg',
	headerFallback: 'https://cdn.snkesports.com/events/images/elements/player/banner.jpg',
}
const header = computed(() => props.player.header || decorations.headerFallback)
const isQualified = computed(() => Boolean(props.qualifications?.length))
</script>

<template>
	<div class="border-snk-light-900/50 @container w-full rounded-xl border bg-white/70 p-1 shadow-lg">
		<img class="h-30 w-full rounded-lg object-cover @xl:h-50" :src="header" :alt="player.header ? player.username : ''" />
		<div class="flex items-end justify-between px-3">
			<div class="relative -mt-16 size-24 shrink-0">
				<img class="absolute top-1/2 left-1/2 size-28 max-w-none -translate-x-1/2 -translate-y-1/2" :src="decorations.star" alt="" v-if="isQualified" />
				<div :class="['bg-snk-blue-500 relative size-24 overflow-hidden rounded-full border-4', isQualified ? 'border-[#e0b138]' : 'border-white']">
					<img class="absolute -top-8 left-1/2 w-52 max-w-none -translate-x-1/2 opacity-70" :src="decorations.avatarBackdrop" alt="" />
					<img class="absolute inset-0 size-full object-cover object-top" :src="player.avatar" :alt="player.username" v-if="player.avatar" />
				</div>
			</div>
			<div class="flex items-center gap-3 py-3 text-base leading-none">
				<a class="transition-transform duration-300 ease-in-out hover:-translate-y-0.5" v-for="social in player.socials" :key="social.link" :href="social.link" :aria-label="social.platform?.name" target="_blank">
					<i class="text-xl" :class="social.platform?.icon" />
				</a>
			</div>
		</div>
		<div class="flex flex-col gap-2 p-3 pt-5 @xl:flex-row @xl:items-end @xl:justify-between @xl:gap-6">
			<div class="flex flex-col gap-2">
				<div class="h4">{{ player.username }}</div>
				<p class="text-sm opacity-70" v-if="player.biography">{{ player.biography }}</p>
			</div>
			<div class="-mx-3 mt-1 -mb-3 flex min-w-0 flex-col gap-1 overflow-hidden rounded-b-lg @xl:mt-0 @xl:-mr-3 @xl:mb-0 @xl:ml-0 @xl:w-auto @xl:rounded-lg" v-if="qualifications?.length">
				<QualificationBanner v-for="qualification in qualifications" :key="`${qualification.title}-${qualification.label}`" :title="qualification.title" :label="qualification.label" />
			</div>
		</div>
	</div>
</template>
